module.exports = __webpack_public_path__ + "assets/d1d8e52433c1159b7c49ea486fb6f121.mp3";